import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../Constants/ApiConstants";

const Orders = () => {

  //Get Product List
  const [products, setProduct] = useState([]);
  const [productLoading, setProductLoading] = useState(false)
  const [fileUrl, setFileUrl] = useState(null)

  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    const result = await axios.get(`${API_BASE_URL}/v1/product/list`);
    console.log("My Data:", result.data.data)
    setProduct(result.data.data.reverse());
  };

  //Set Product..

  const [selectProducts, selectedProduct] = useState({
    product_id: "",
    batch_id: "",
  });

  const { product_id, batch_id } = selectProducts;

  const onProductChange = async e => {
    setBatch([])
    setFileUrl(null)
    const response = await fetch(`${API_BASE_URL}/v1/batch/list/${e.target.value}`)

    if (!response.ok) {
      console.log(response.body)
      return
    }

    const result = await response.json()
    setBatch(result.data.reverse())
  };

  //Get Batch List By Product IT
  const [batches, setBatch] = useState([]);

  //Get Order List
  const [orders, setOrder] = useState([]);


  const loadOrders = async e => {
    setFileUrl(null)
    setProductLoading(true)
    const response = await fetch(`${API_BASE_URL}/v1/order/list/${e.target.value}`)

    if (!response.ok) {
      const result = await response.json()
      toast.error(result.message)
      setOrder([])
      setProductLoading(false)
      return
    }
    const result = await response.json()
    setOrder(result.data.orders)
    setProductLoading(false)
    setFileUrl(result.data.file_url)
  };

  return (

    <div className="w-full mt-12">

      <ToastContainer />
      <main className="w-full flex-grow p-6">

        <h1 class="w-full text-3xl text-black">Filter Orders</h1>
        <div className="flex flex-wrap">
          <div className="w-full  my-6 pr-0 lg:pr-2">
            <div class="flex justify start bg-white rounded shadow-xl p-5">
              <div>
                <form className="pr-2">
                  <div className="">
                    <label className="block text-sm text-gray-600" for="product">Products</label>
                    <select required="true" class="form-select form-select-sm w-80
                                   appearance-none 
                                   block w-full px-2 py-1
                                    text-sm font-normal
                                    w-full px-5 py-1 text-gray-700 bg-gray-200 rounded
                                     text-gray-700 bg-white bg-clip-padding bg-no-repeat
                                     border border-solid border-gray-300
                                     rounded
                                     transition
                                     ease-in-out  m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
                                     " aria-label=".form-select-lg example" onChange={e => onProductChange(e)} name="product_id">

                      <option>Select Product</option>
                      {products.map((product) => (
                        <option value={product.id}>{product.name}</option>
                      ))}
                    </select>
                  </div>
                </form>
              </div>
              <div>
                <form className="pr-2" onSubmit={e => loadOrders(e)}>
                  <div className="">
                    <label className="block text-sm text-gray-600" for="product">Batches</label>
                    <select required="true" class="form-select form-select-sm w-80
                                   appearance-none 
                                   block w-full px-2 py-1
                                    text-sm font-normal
                                    w-full px-5 py-1 text-gray-700 bg-gray-200 rounded
                                     text-gray-700 bg-white bg-clip-padding bg-no-repeat
                                     border border-solid border-gray-300
                                     rounded
                                     transition
                                     ease-in-out  m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none
                                     " aria-label=".form-select-lg example" onChange={e => loadOrders(e)} name="batch_id">

                      <option>Select Batch</option>
                      {batches.map((batch) => (
                        <option value={batch.id}>{batch.name}</option>

                      ))}
                    </select>
                  </div>
                </form>
              </div>
              {fileUrl != null &&
                <div className="pt-4">
                  <a href={fileUrl}>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded">
                      Download
                    </button>
                  </a>
                </div>}
            </div>
          </div>
        </div>


        <h1 className="text-3xl text-black pb-6">Orders</h1>
        {productLoading && <h3>Loading</h3>}
        {!productLoading && orders.length == 0 && <h3>No data</h3>}
        {!productLoading && orders.length > 0 && <div className=" bg-white overflow-auto">
          <table className="text-left w-full border-collapse">
            <thead>
              <tr>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">#</th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Customer</th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Area</th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">NearByPlace</th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Phone</th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Packet</th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Chicken</th>
                <th className="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Type</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr className="hover:bg-grey-lighter">
                  <td className="py-4 px-6 border-b border-grey-light">{index + 1}</td>
                  <td className="py-4 px-6 border-b border-grey-light">{order.user_profile.first_name} {order.user_profile.last_name}</td>
                  <td className="py-4 px-6 border-b border-grey-light">{order.user_address.area.name}</td>
                  <td className="py-4 px-6 border-b border-grey-light">{order.user_address.near_by_place.name}</td>
                  <td className="py-4 px-6 border-b border-grey-light">{order.user.mobile}</td>
                  <td className="py-4 px-6 border-b border-grey-light">{order.required_packet}</td>
                  <td className="py-4 px-6 border-b border-grey-light">{order.total_chicken}</td>
                  <td className="py-4 px-6 border-b border-grey-light">{order.individual_order ? "Individual" : "Subscribed"}</td>

                </tr>

              ))}

            </tbody>
          </table>
        </div>}
      </main>


    </div>
  )
}

export default Orders

